<template>
  <transition name="modal" appear>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div style="height: 20px; position: fixed">
            <font-awesome-icon
              icon="times"
              class="close-icon"
              @click="$emit('close')"
            />
          </div>
          <div class="modal-body">
            <div>
              <font-awesome-icon
                icon="chevron-right"
                size="2x"
                class="navigators"
                v-show="showRight"
                @click="$emit('showNext')"
                title="پیام بعدی"
              />
            </div>
            <div class="messageContent">
              <div>
                <img
                  class="image"
                  :src="imageUrl"
                  @error="imageUrlAlt"
                  @load="imageLoad"
                />
              </div>

              <div class="sendDate">{{ sendDate }}</div>
              <div class="texts">
                <div class="text">
                  <b>{{ title }}</b>
                </div>
                <div class="text">
                  <span v-html="convertHTMLBody(body)"></span>
                </div>
                <div class="text">
                  <a :href="link" target="_blank">لینک پیام</a>
                </div>
              </div>
            </div>
            <div>
              <font-awesome-icon
                icon="chevron-left"
                class="navigators"
                size="2x"
                v-show="showLeft"
                @click="$emit('showPrevious')"
                title="پیام قبلی"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { convertHTMLBody } from "@/utils/constants";
export default {
  props: [
    "title",
    "body",
    "imageUrl",
    "sendDate",
    "link",
    "showLeft",
    "showRight",
  ],
  methods: {
    imageUrlAlt(event) {
      event.target.style = "display : none";
    },
    imageLoad(event) {
      event.target.style = "display : inherit";
    },
    convertHTMLBody,
  },
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.33);
  display: table;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 95%;

  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  overflow: auto;
  max-height: 95vh;
  margin: 0px auto;
}

.modal-body {
  display: flex;
}

.messageContent {
  width: 100%;
  margin: 0 10px;
}

.navigators {
  top: calc(50% - 16px);
  position: relative;
  cursor: pointer;
  color: #22480c;
}

/* .modal-leave-active {
  transition: transform 1s, opacity 0.4s linear;
}

.modal-enter-active {
  transition: transform 1s, opacity 0.4s linear, background-color 1.5s linear;
}

.modal-enter,
.modal-leave-to {
  background-color: inherit;
  opacity: 0;
  transform: scale(0.4);
} */
.close-icon {
  cursor: pointer;

  position: sticky;
  float: right;
}
.image {
  width: 90%;
  background-size: 70%;
  display: none;
  margin: 0 5%;
}
.sendDate {
  direction: ltr;
  margin: 20px;
}
.text {
  padding: 10px;
  width: 100%;
}

.fa-times {
  margin: 0 !important;
}
@media only screen and (min-width: 768px) {
  .modal-container {
    width: 80%;
  }
  .image {
    width: 80%;
    margin: 20px 10%;
  }
}
@media only screen and (min-width: 1024px) {
  .modal-container {
    width: 60%;
  }
  .image {
    width: 70%;
    margin: 20px 15%;
  }
}

@media only screen and (min-width: 1600px) {
  .modal-container {
    width: 40%;
  }
  .image {
    width: 60%;
    margin: 20px 20%;
  }
}
</style>
